export default __webpack_public_path__ + "static/media/mobileAtoirSlide.2a3071b2.png";